import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import Navigator from './components/menu/Navigator.vue'
import ToggleButton from 'vue-js-toggle-button'
import './imports/BootstrapVue.js'
import './imports/CKeditor.js'
import 'font-awesome/css/font-awesome.min.css'
import VueCurrencyInput from 'vue-currency-input'
 
Vue.use(VueCurrencyInput)
Vue.use(VueTheMask)
Vue.use(ToggleButton)

Vue.component('navigator', Navigator)
Vue.config.productionTip = false

export const bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
